import { registerLocaleData } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import 'reflect-metadata';
import localeEn from '@angular/common/locales/en';

localeEn[10][0] = 'MM/dd/yyyy';

registerLocaleData(localeEn);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
